import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCheck,
  faTimes,
  faSearch,
  faHistory,
  faChevronDown,
  faMoneyBillWave,
  faGraduationCap,
  faUniversity,
  faIndustry
} from '@fortawesome/free-solid-svg-icons'

const init = () => {
  library.add(
    faCheck,
    faTimes,
    faSearch,
    faHistory,
    faChevronDown,
    faMoneyBillWave,
    faGraduationCap,
    faUniversity,
    faIndustry
  )
}

export { init }
